module.exports = __webpack_public_path__ + "img/palm.a6d0147d.svg";